import type { FaireProductEntity } from "../../entity_types/product";

export const p_y2bd69pbbq: FaireProductEntity = {
  token: "p_y2bd69pbbq",
  type: "product",
  name: "Organic Lip Balm (Pack of 4)",
  brandToken: "b_1yelunfq",
  brandName: "Beauty By Earth",
  imageUrl: "https://cdn.faire.com/fastly/caca9eb3a5a43404acce13ccd675f9f1342c6bcb989f88cb8be18b010dad0e81.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56e613b97b8501f078e8b121216d22cb45d58a68970cefca9d83fbc77f23175e.jpeg",
    "https://cdn.faire.com/fastly/761b88bd79e6bbb9a988fd9f697f0eeefffc523003ee439e4bf6674cbf2e68d3.jpeg",
    "https://cdn.faire.com/fastly/c1c1cc17c47c40b98dc3a0e94f56ba22bbbfcfb636214a243c4f4b644f272cac.jpeg",
    "https://cdn.faire.com/fastly/41c7ff77fe6173b0c2279e1fd1bd6aef29ea1bc9bd73aaf71be6dcc5761b272d.jpeg",
    "https://cdn.faire.com/fastly/5e5d5c4f3c0f618ae9d6e7fdfebabb3446fe29256302712008f06410415dcc1a.jpeg",
    "https://cdn.faire.com/fastly/1da2b7ab20200814d6e5a16518aa824aac7ba2570df09dba5d01cee4e11957f2.jpeg",
    "https://cdn.faire.com/fastly/52503b59f536532f9f663d313cde1b38b4bd75862583477c19a8fac97f250b84.jpeg",
    "https://cdn.faire.com/fastly/a4182da0e68dc976c221383d661ae9afde13a2f8a33c745b70438f094fd5ea60.jpeg",
    "https://cdn.faire.com/fastly/6c1991d81884537780c8abe7c29d6b325ce2ee0409d9711dd89f162a79ac409f.jpeg",
    "https://cdn.faire.com/fastly/c6e9e60ae79e85a52aceacb5922c35479177bdb1e16bf8951f859d307e773600.jpeg",
    "https://cdn.faire.com/fastly/52a5bac537e0856b3853e6f3140ede06fc7f0f244dc3d74168efd1fe1a1fccc8.jpeg"
  ],
  priceDollars: 9.69,
  description: "Great alternative to chapstick for men, women and kids! Made in the USA with quality organic ingredients. This organic chapstick gift set  is a lip moisturizer that will help soothe very dry lips and keep them protected & hydrated.\n\n🌿 USDA Certified Organic\n🌿 Leaves lips hydrated\n🌿 Made in the USA\n🌿 Always Cruelty Free! \n🌿 Petroleum Free!",
  tags: [],
  msrpDollars: 16.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:57.163Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
